// extracted by mini-css-extract-plugin
export default {"chat_action":"_1aUasYi7XhgpB7smJK0mEJ","chat_messages":"_2m9n71fMRoaQNSzykMtUwP","only_chat":"_3yXJHg5yFchyr2c1eAuIAK"};